var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-layers-list"},[_c('r-list',{attrs:{"list":_vm.layers,"tools-list":_vm.tools,"active-list":_vm.activeLayers,"loading-list":_vm.loadingLayers},on:{"node-click-handler":e => _vm.toggleLayer(e),"tool-click-handler":e => _vm.toggleSettings(e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }